module.exports = __webpack_public_path__ + "static/media/posta.f76e6f00.jpg";